import { useMutation, MutationConfigType, UseMutationResult } from "~/libs";

import { ApiClient } from "~/utils";

import { ResponseMessageType } from "~/domains";

type RequestDataType = {
  skillEvaluationStandardSummaryCategoryId: string;
};

const request = ({
  skillEvaluationStandardSummaryCategoryId,
}: RequestDataType) => {
  return new ApiClient()
    .post<ResponseMessageType>(
      `/api/members/skill_evaluation_standard_summary_categories/${skillEvaluationStandardSummaryCategoryId}/page_views`,
    )
    .then((res) => {
      return res.data;
    });
};

type PropsType = {
  options?: MutationConfigType<typeof request>;
};

export const useApisMembersSkillEvaluationStandardSummaryCategoriesPageViewsCreate =
  ({ options = {} }: PropsType = {}): UseMutationResult<
    ResponseMessageType,
    RequestDataType
  > => {
    return useMutation(request, { ...options });
  };
